// extracted by mini-css-extract-plugin
module.exports = {"body":"ImagesAddStable_body__2FVOz"};